import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

// 获取店铺看板列表数据
export function shopBoardList(data){
	return request.post(config.baseApi+"/merchant/ShopBoard/list",data)
}
// 获取/保存指标配置
export function shopBoardFieldConfig(data){
	return request.post(config.baseApi+"/merchant/ShopBoard/fieldConfig",data)
}
// 店铺看板分组列表
export function shopBoardGroupList(data){
	return request.get(config.baseApi+"/merchant/shop-board/groups",data)
}
// 创建店铺看板分组
export function shopBoardGroupCreate(data){
	return request.post(config.baseApi+"/merchant/shop-board/groups",data)
}
// 更新店铺看板分组
export function shopBoardGroupUpdate(id,data){
	return request.put(config.baseApi+`/merchant/shop-board/groups/${id}`,data)
}
// 删除店铺看板分组
export function shopBoardGroupDelete(id){
	return request.delete(config.baseApi+`/merchant/shop-board/groups/${id}`)
}
// 批量设置店铺看板分组
export function shopBoardBatchSetGroup(data){
	return request.post(config.baseApi+"/merchant/shop-board/batch-set-group",data)
}
// 获取店铺看板详情数据
export function shopBoardDetail(data){
	return request.post(config.baseApi+"/merchant/ShopBoard/detail",data)
}
// 获取店铺数据详情
export function shopDataDetail(data){
	return request.get(config.baseApi+"/merchant/shop-data/detail",data)
}
// 获取店铺数据汇总列表
export function shopDataSummary(data){
	return request.post(config.baseApi+"/merchant/shop-data/summary",data)
}
// 获取店铺列表
export function getShopList(data){
	return request.get(config.baseApi+"/merchant/shop/list",data)
}
// 商品看板列表
export function productBoardList(data){
	return request.post(config.baseApi+"/merchant/product-data/summary",data)
}
// 商品指标配置
export function productBoardFieldConfig(data){
	return request.post(config.baseApi+"/merchant/ProductBoard/fieldConfig",data)
}
// 商品看板分组列表
export function productBoardGroupList(data){
	return request.get(config.baseApi+"/merchant/product-board/groups",data)
}
// 创建商品看板分组
export function productBoardGroupCreate(data){
	return request.post(config.baseApi+"/merchant/product-board/groups",data)
}
// 更新商品看板分组
export function productBoardGroupUpdate(id,data){
	return request.put(config.baseApi+`/merchant/product-board/groups/${id}`,data)
}
// 删除商品看板分组
export function productBoardGroupDelete(id){
	return request.delete(config.baseApi+`/merchant/product-board/groups/${id}`)
}
// 批量设置商品看板分组
export function productBoardBatchSetGroup(data){
	return request.post(config.baseApi+"/merchant/product-board/batch-set-group",data)
}
// 获取店铺违规记录列表
export function getShopViolations(data){
	return request.get(config.baseApi+"/merchant/shop-data/violations",data)
}
// 获取微信小店详情数据
export function wechatShopDataDetail(data){
	return request.post(config.baseApi+"/merchant/shop-data/wechat-detail",data)
}
